import React from 'react';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import { LinearProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import { AccountBox } from 'material-ui-icons';
import { TextField } from 'material-ui';
import OLYWebPageComponent from '../OLYWebPageComponent';
import DropDownMenu from '../../ui/DropDownMenu';
import { getCurrentUser, saveCurrentUser } from './userServices';
import ChangePasswordDialog from '../ChangePassword/ChangePasswordDialog';

import { translate } from 'react-i18next';
import { Typography, withStyles } from '../../../node_modules/material-ui';

import { reconnect } from '../Login/loginService';

const styles = theme => ({
    tableTitle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        fontWeight: 300
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: 'var(--secondary-button-color)',
    },
    FormControl: {
        display: 'flex',
        width: '350px',
        margin: '1.3rem 0 0 0'        
    }
});
class UserView extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            user: {
                userDetail: {
                    language: ''
                }
            },
            openChangePwdDialog: false
        };
        this.pageName = 'UserView';
    }

    componentDidMount = () => {
        this.getUser();
    }

    openModal = () => {
        this.setState({ openChangePwdDialog: true });
    };

    closeModal = () => {
        this.setState({ openChangePwdDialog: false });
    };

    getLangsAvail = () => {
        const langAvail = JSON.parse(localStorage.getItem('language_avail'));
        const { t } = this.props;

        return langAvail.map(lang => {
            const upperLang = lang.toUpperCase();
            return { label: t(`LANG.${upperLang}`), value: upperLang }
        });

    }

    getUser = () => {
        getCurrentUser().then(result => {
            //console.log(result);
            this.setState({ user: result });
        }).catch(error => {
            alert(error.message);
        }).finally(data => {
            this.setState({ loading: false });
        });
    };

    saveUser = () => {
        // TODO: also check for valid emails using regex
        if (!this.state.user.firstName.trim() || !this.state.user.email.trim()) {
            alert(this.props.t('CONFIRM_BOOKING.PLEASE_COMPLETE_CLIENT_DATA'));
            return;
        }
        this.setState({ loading: true });
        saveCurrentUser(this.state.user)
            .then(r1 => {
                return reconnect();
            })
            .then(r2 => {
                window.location.reload();
            })
            .catch(error => {
                alert(error.message + '\n' + (error.detailedMessage ? error.detailedMessage : ''));
            })
            .finally(data => {
                this.setState({ loading: false });
            });
    };

    render() {
        const { classes, t } = this.props;
        return (
            <div>
                <div style={{ margin: '5px' }}>
                    {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                </div>
                <Paper style={{ margin: 15, padding: 20 }}>
                    <Typography className={classes.tableTitle}>
                        <AccountBox style={{ width: 32, height: 32, float: 'left' }} />
                        <strong style={{ paddingLeft: 8 }}>{t('PAGE_TITLES.UserView')}</strong>
                    </Typography>
                    <br />
                    <br />
                    <div style={{ paddingLeft: 38 }}>
                        <FormControl component="fieldset" className={classes.FormControl}>
                            <TextField
                                fullWidth
                                label={t('USER.USER_NAME')}
                                required={false}
                                disabled={true}
                                value={this.state.user.userName}
                                placeholder={t('USER.USER_NAME')}
                                InputLabelProps={{
                                    shrink: true,
                                    className: classes.inputLabel
                                }}
                                onChange={event => {
                                    let user = this.state.user;
                                    user.userName = String(event.target.value);
                                    this.setState({ user: user });
                                }}
                            />
                        </FormControl>                       
                        <FormControl component="fieldset" className={classes.FormControl}>
                            <TextField
                                fullWidth
                                label={t('USER.FIRST_NAME')}
                                required={true}
                                value={this.state.user.firstName}
                                placeholder={t('USER.FIRST_NAME')}
                                InputLabelProps={{
                                    shrink: true,
                                    className: classes.inputLabel
                                }}
                                onChange={event => {
                                    let user = this.state.user;
                                    user.firstName = String(event.target.value);
                                    this.setState({ user: user });
                                }}
                                error={!this.state.user.firstName || !this.state.user.firstName.trim()}
                            />
                        </FormControl>                        
                        <FormControl className={classes.FormControl} component="fieldset">
                            <TextField
                                fullWidth
                                label={t('USER.EMAIL')}
                                required={true}
                                value={this.state.user.email}
                                placeholder={t('USER.EMAIL')}
                                InputLabelProps={{
                                    shrink: true,
                                    className: classes.inputLabel
                                }}
                                onChange={event => {
                                    let user = this.state.user;
                                    user.email = String(event.target.value);
                                    this.setState({ user: user });
                                }}
                                error={!this.state.user.email || !this.state.user.email.trim()}
                            />
                        </FormControl>
                        <FormControl component="fieldset" className={classes.FormControl + ' cmsOwndataDropdown'}>
                            <DropDownMenu
                                style={{width: '300px!important', margin: '1.3rem 0 0 0' }}                               
                                label={t('USER.LANGUAGE')}
                                selection={this.state.user.userDetail.language}
                                onChange={value => {
                                    let user = this.state.user;
                                    user.userDetail.language = String(value);
                                    this.setState({ user: user });
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                    className: classes.inputLabel
                                }}
                                menuOptions={this.getLangsAvail()}
                            />
                        </FormControl>
                        
                        <FormControl component="fieldset" className={classes.FormControl}>
                            <TextField
                                fullWidth
                                label={t('USER.JOB_TITLE')}
                                required={false}
                                value={this.state.user.userDetail.jobTitle}
                                placeholder={t('USER.JOB_TITLE')}
                                InputLabelProps={{
                                    shrink: true,
                                    className: classes.inputLabel
                                }}
                                onChange={event => {
                                    let user = this.state.user;
                                    user.userDetail.jobTitle = String(event.target.value);
                                    this.setState({ user: user });
                                }}
                            />
                        </FormControl>
                        <br /><br />
                        <Typography variant='caption'>{t('CONFIRM_BOOKING.REQUIRED_FIELDS')}</Typography>
                        <br /><br />
                        <Button
                            style={{color:'var(--primary-button--text-color)', backgroundColor: 'var(--primary-button-color)'}}
                            onClick={this.openModal}
                            disabled={this.state.loading}
                            color="secondary"><u>{t('CHANGE_PASSWORD.CHANGE_PASSWORD')}</u>
                        </Button>
                        <Button color="primary" variant="raised"
                            style={{ marginLeft: 65 }}
                            onClick={() => this.saveUser()}
                            disabled={this.state.loading} >{t('COMMON.SAVE')}
                        </Button>
                    </div>
                </Paper>
                <ChangePasswordDialog
                    open={this.state.openChangePwdDialog}
                    onClose={this.closeModal}
                />
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(UserView));


// WEBPACK FOOTER //
// ./src/components/User/UserView.js